'use client';
import {
  CatSkeleton,
  CatCard,
  CatGrid,
  CatGridItem
} from 'components/blocks-components';
import styles from './parts-diagram-loader.module.scss';
import { DIAGRAM_VIEW, LIST_VIEW } from 'constants/parts-diagram';

export interface PartsDiagramLoaderProps {
  variant?: string;
  count?: number;
}

const LoaderCard = () => (
  <CatGridItem>
    <CatCard>
      <div className={styles['card-container']}>
        <div className={styles['top-row']}>
          <div>
            <CatSkeleton
              size="sm"
              className={styles['reference-number-skeleton']}
            />
          </div>

          <div className="d-flex flex-column gap-1 flex-grow-1">
            <div>
              <CatSkeleton size="sm" className={styles['part-name-skeleton']} />
            </div>
            <div>
              <CatSkeleton size="sm" className={styles['price-skeleton']} />
            </div>
            <div>
              <CatSkeleton
                size="sm"
                className={styles['description-skeleton']}
              />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column gap-1">
            <div>
              <CatSkeleton
                size="sm"
                className={styles['quantity-fitment-skeleton']}
              />
            </div>
            <div>
              <CatSkeleton
                size="sm"
                className={styles['quantity-fitment-skeleton']}
              />
            </div>
          </div>

          <div>
            <CatSkeleton size="sm" className={styles['add-to-cart-skeleton']} />
          </div>
        </div>
      </div>
    </CatCard>
  </CatGridItem>
);

const PartsDiagramLoader = ({
  variant = DIAGRAM_VIEW,
  count = 8
}: PartsDiagramLoaderProps) => {
  const renderDiagramLoader = () => (
    <div>
      <CatSkeleton size="xxl" className={styles['parts-diagram-loader']} />
    </div>
  );

  const renderListLoader = () => {
    return (
      <div className="p-3">
        <CatGrid gap="sm">
          {Array.from({ length: count }, (_, i) => (
            <LoaderCard key={i} />
          ))}
        </CatGrid>

        <div className={styles['add-all-button-container']}>
          <div className={styles['add-all-to-cart-skeleton']}>
            <CatSkeleton />
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    switch (variant) {
      case DIAGRAM_VIEW:
        return renderDiagramLoader();
      case LIST_VIEW:
        return renderListLoader();
      default:
        return renderDiagramLoader();
    }
  };

  return <div>{renderContent()}</div>;
};

export default PartsDiagramLoader;
